<template>
	<div class="date-picker-mobile-container">
		<smooth-picker ref="dateTimePicker" :data="setDateOptions" :change="handleDateChange"/>
		<BaseButton title="Choose"
			:classNames="['button--modifier']"
			@click.prevent="handleChoose" />
	</div>
</template>

<script>
	import * as moment from "moment";
	import timeMixin from '@Mixin/timeMixin';
	import pickerMixin from '@Mixin/pickerMixin';
	import { each, map, findIndex, includes } from 'lodash';
	const groupKeys = {
		day: 0,
		hour: 2,
		minutes: 4,
		meridiem: 5,
	};
	export default {
		mixins: [
			timeMixin,
			pickerMixin,
		],
		data() {
			return {
				days: [],
				hours: [],
				minutes: [],
				meridiem: [],
				selectedDay: 0,
				selectedHour: 0,
				selectedMinutes: 0,
				selectedMeridiem: 0,
			};
		},
		computed: {
			setDateOptions() {
				this.refreshDateTime();
				return [
					{
						currentIndex: this.selectedDay,
						flex: 2,
						list: this.days,
						textAlign: 'center',
						className: 'row-group',
					},
					{
						divider: true,
						flex: 1,
						text: 'at',
						textAlign: 'center',
						className: 'divider'
					},
					{
						currentIndex: this.selectedHour,
						flex: 1,
						list: this.hours,
						textAlign: 'center',
						className: 'row-group',
					},
					{
						divider: true,
						flex: 1,
						text: ':',
						textAlign: 'center',
						className: 'divider'
					},
					{
						currentIndex: this.selectedMinutes,
						flex: 1,
						list: this.minutes,
						textAlign: 'center',
						className: 'row-group',
					},
					{
						currentIndex: this.selectedMeridiem,
						flex: 1,
						list: this.meridiem,
						textAlign: 'center',
						className: 'row-group',
					},
				];
			},
		},
		methods: {
			getDayIndexUpdate() {
				const time = moment(this.orderTime);
				const dayIndex =  time.diff(moment(), 'days');
				this.selectedDay = dayIndex;
				return {
					key: groupKeys.day,
					index: dayIndex,
				};
			},
			getHourIndexUpdate() {
				const time = moment(this.orderTime);
				let currentHour = moment(time).hour() % 12;
				if (currentHour === 0) {
					currentHour = 12;
				}
				const hourIndex = findIndex(this.hours, (hour) => {
					return hour === `${currentHour}`.padStart(2, '0');
				});
				this.selectedHour = hourIndex;
				return {
					key: groupKeys.hour,
					index: hourIndex,
				};
			},
			getMinutesIndexUpdate() {
				const time = moment(this.orderTime);
				const currentMinutes = moment(time).minutes();
				const minutesIndex = findIndex(this.minutes, (minutes) => {
					return minutes === `${currentMinutes}`.padStart(2, '0');
				});
				this.selectedMinutes = minutesIndex;
				return {
					key: groupKeys.minutes,
					index: minutesIndex,
				};
			},
			getMeridiemIndexUpdate() {
				const time = moment(this.orderTime);
				const currentHour = moment(time).hour();
				let meridiemIndex = this.selectedMeridiem;
				// TODO needs to check availablility
				if (currentHour >= 12 && meridiemIndex === 0) {
					this.selectedMeridiem = 1;
					meridiemIndex = 1;
				}
				return {
					key: groupKeys.meridiem,
					index: meridiemIndex,
				};
			},
			refreshDateTime(groupIndex) {
				const time = moment(this.orderTime);
				if (time.isBefore(moment())) {
					this.setOrderTime(this.minASAPTime);
					this.updatePicker([
						this.getDayIndexUpdate(),
						this.getHourIndexUpdate(),
						this.getMinutesIndexUpdate(),
					]);
				}
				const includeForUpdate = [groupKeys.hour];
				if (includes(includeForUpdate), groupIndex) {
					this.updatePicker([
						this.getMeridiemIndexUpdate(),
					]);
				}
			},
			updatePicker(updates) {
				const picker = this.$refs['dateTimePicker'];
				if (!picker) {
					return;
				}
				each(updates, (update) => {
					picker.currentIndexList[update.key] = update.index;
				});
			},
			initializeState() {
				const time = this.minASAPTime;
				this.setOrderTime(time);

				const allHours = [...new Array(12)].map((x,i) => `${i+1}`.padStart(2,'0'));
				const allMinutes = ['00', '15', '30', '45'];

				this.hours = allHours;
				this.minutes = allMinutes;
				this.days = map(this.getDays(), 'name');
				this.meridiem = map(this.getAvailableMeridiem(), 'name');

				this.refreshDateTime();
				this.updatePicker([
					this.getHourIndexUpdate(),
					this.getMinutesIndexUpdate(),
					this.getMeridiemIndexUpdate(),
				]);
			},
			handleDateChange(groupIndex, itemIndex) {
				const picker = this.$refs['dateTimePicker'];
				switch (groupIndex) {
					case groupKeys.day:
						this.selectedDay = itemIndex;
						break;
					case groupKeys.hour:
						this.selectedHour = itemIndex;
						break;
					case groupKeys.minutes:
						this.selectedMinutes = itemIndex;
						break;
					case groupKeys.meridiem:
						this.selectedMeridiem = itemIndex;
						break;
					default:
						break;
				}
				const dayIndex = this.selectedDay;
				const hour = this.hours[this.selectedHour];
				const minutes = this.minutes[this.selectedMinutes];
				const meridiem = this.meridiem[this.selectedMeridiem];
				const scheduledTime = this.getScheduledTime({
					day: dayIndex,
					hour,
					minutes,
					meridiem,
				});
				this.setOrderTime(scheduledTime);
				this.refreshDateTime(groupIndex);
			},
		},
		mounted() {
			this.initializeState();
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.smooth-picker {
		font-size: 32px;
	}
	@include phone {
		.smooth-picker {
			font-size: 5vw;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseDatePickerMobile.vue